import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenStartsWith, XsrfTokenKey } from '../../types/aclave';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const csrfToken = this.getCsrfToken();

        if (csrfToken) {
            const cloned = req.clone({
                headers: req.headers.set(XsrfTokenKey, csrfToken),
            });
            return next.handle(cloned);
        } else {
            return next.handle(req);
        }
    }

    private getCsrfToken(): string | null {
        return (
            document.cookie
                .split('; ')
                .find(row => row.startsWith(TokenStartsWith))
                ?.split('=')[1] || null
        );
    }
}
